import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_urls } from "../../utils/api-urls/index.js";

const SplLive = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [config, setConfig] = useState({
        videoUrl: "",
        title: "Sanatani Services",
        isActive: false,
    });
    const [message, setMessage] = useState({ text: "", type: "" });

    useEffect(() => {
        fetchConfig();
    }, []);

    const fetchConfig = async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(`${api_urls}api/admin/spl-live`);
            if (data.status && data.data) {
                setConfig({
                    videoUrl: data.data.videoUrl || "",
                    title: data.data.title || "Sanatani Services",
                    isActive: data.data.isActive || false,
                });
            }
        } catch (error) {
            console.error("SPL Live fetch error:", error);
            setMessage({ text: "Failed to load SPL Live config", type: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        if (config.isActive && !config.videoUrl) {
            setMessage({ text: "Please enter a video URL before activating!", type: "error" });
            return;
        }
        setSaving(true);
        setMessage({ text: "", type: "" });
        try {
            const { data } = await axios.put(`${api_urls}api/admin/spl-live`, config);
            if (data.status) {
                setMessage({ text: "SPL Live updated successfully! ✅", type: "success" });
            } else {
                setMessage({ text: "Failed to save", type: "error" });
            }
        } catch (error) {
            setMessage({ text: "Error saving SPL Live config", type: "error" });
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
                <div style={{ fontSize: "18px", color: "#666" }}>Loading SPL Live config...</div>
            </div>
        );
    }

    return (
        <div style={{ padding: "20px", maxWidth: "900px" }}>
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "25px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    <h2 style={{ margin: 0, fontSize: "24px", fontWeight: "700" }}>🔴 SPL Live</h2>
                    <span style={{
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "700",
                        backgroundColor: config.isActive ? "#22c55e" : "#e5e7eb",
                        color: config.isActive ? "#fff" : "#6b7280",
                    }}>
                        {config.isActive ? "ACTIVE" : "INACTIVE"}
                    </span>
                </div>
            </div>

            {/* Message */}
            {message.text && (
                <div style={{
                    padding: "12px 16px",
                    marginBottom: "20px",
                    borderRadius: "8px",
                    backgroundColor: message.type === "success" ? "#dcfce7" : "#fee2e2",
                    color: message.type === "success" ? "#166534" : "#991b1b",
                    fontWeight: "500",
                }}>
                    {message.text}
                </div>
            )}

            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                {/* Config Card */}
                <div style={{
                    flex: "1 1 500px",
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "25px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    border: "1px solid #e5e7eb",
                }}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "18px" }}>Video Configuration</h3>
                    <p style={{ margin: "0 0 20px 0", color: "#6b7280", fontSize: "14px" }}>
                        Set the live video link that will appear as an animated ticker on the app's home screen.
                    </p>

                    <hr style={{ border: "none", borderTop: "1px solid #e5e7eb", margin: "0 0 20px 0" }} />

                    {/* Toggle */}
                    <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "12px" }}>
                        <label style={{ position: "relative", width: "48px", height: "26px", cursor: "pointer" }}>
                            <input
                                type="checkbox"
                                checked={config.isActive}
                                onChange={(e) => setConfig({ ...config, isActive: e.target.checked })}
                                style={{ display: "none" }}
                            />
                            <div style={{
                                width: "48px",
                                height: "26px",
                                borderRadius: "13px",
                                backgroundColor: config.isActive ? "#22c55e" : "#d1d5db",
                                transition: "background 0.3s",
                                position: "relative",
                            }}>
                                <div style={{
                                    width: "22px",
                                    height: "22px",
                                    borderRadius: "50%",
                                    backgroundColor: "#fff",
                                    position: "absolute",
                                    top: "2px",
                                    left: config.isActive ? "24px" : "2px",
                                    transition: "left 0.3s",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                }} />
                            </div>
                        </label>
                        <div>
                            <div style={{ fontWeight: "600", fontSize: "14px" }}>Enable SPL Live</div>
                            <div style={{ fontSize: "12px", color: "#6b7280" }}>Show animated ticker on app home screen</div>
                        </div>
                    </div>

                    {/* Title Input */}
                    <div style={{ marginBottom: "20px" }}>
                        <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", fontSize: "14px" }}>
                            Ticker Title
                        </label>
                        <input
                            type="text"
                            value={config.title}
                            onChange={(e) => setConfig({ ...config, title: e.target.value })}
                            placeholder="Sanatani Services"
                            style={{
                                width: "100%",
                                padding: "10px 14px",
                                borderRadius: "8px",
                                border: "1px solid #d1d5db",
                                fontSize: "14px",
                                outline: "none",
                                boxSizing: "border-box",
                            }}
                        />
                        <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                            This text appears on the animated ticker bar
                        </div>
                    </div>

                    {/* Video URL Input */}
                    <div style={{ marginBottom: "25px" }}>
                        <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", fontSize: "14px" }}>
                            Video URL
                        </label>
                        <input
                            type="text"
                            value={config.videoUrl}
                            onChange={(e) => setConfig({ ...config, videoUrl: e.target.value })}
                            placeholder="https://www.youtube.com/watch?v=... or any video link"
                            style={{
                                width: "100%",
                                padding: "10px 14px",
                                borderRadius: "8px",
                                border: "1px solid #d1d5db",
                                fontSize: "14px",
                                outline: "none",
                                boxSizing: "border-box",
                            }}
                        />
                        <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                            Paste YouTube URL or any direct video link. Opens when user taps the ticker.
                        </div>
                    </div>

                    {/* Save Button */}
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        style={{
                            padding: "12px 30px",
                            borderRadius: "8px",
                            border: "none",
                            backgroundColor: saving ? "#9ca3af" : "#FF6B35",
                            color: "#fff",
                            fontSize: "15px",
                            fontWeight: "700",
                            cursor: saving ? "not-allowed" : "pointer",
                            transition: "background 0.2s",
                        }}
                    >
                        {saving ? "Saving..." : "💾 Save SPL Live Settings"}
                    </button>
                </div>

                {/* Preview Card */}
                <div style={{ flex: "0 1 300px" }}>
                    <div style={{
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        border: "1px solid #e5e7eb",
                        marginBottom: "15px",
                    }}>
                        <h4 style={{ margin: "0 0 12px 0" }}>Preview</h4>
                        <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 15px 0" }}>
                            How the ticker looks on the app:
                        </p>

                        {/* Ticker Preview */}
                        <div style={{
                            background: "linear-gradient(135deg, #FF6B35 0%, #FF4500 50%, #FF6B35 100%)",
                            borderRadius: "8px",
                            padding: "10px 14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            overflow: "hidden",
                        }}>
                            <span style={{ fontSize: "16px" }}>📺</span>
                            <span style={{ color: "#fff", fontWeight: "700", fontSize: "12px", whiteSpace: "nowrap" }}>
                                {config.title || "Sanatani Services"}
                            </span>
                            <span style={{
                                color: "#FFE4B5",
                                fontSize: "11px",
                                fontWeight: "600",
                                flex: 1,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }}>
                                स्पेशल लाइव • अभी देखें
                            </span>
                            <span style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "3px",
                            }}>
                                <span style={{
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    backgroundColor: "#fff",
                                    animation: "blink 1.5s infinite",
                                }} />
                                <span style={{ color: "#fff", fontSize: "10px", fontWeight: "800" }}>LIVE</span>
                                <span style={{ color: "#fff", fontSize: "14px", marginLeft: "4px" }}>▶</span>
                            </span>
                        </div>

                        <style>{`@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }`}</style>

                        {/* Status info */}
                        {!config.isActive && (
                            <div style={{ marginTop: "12px", padding: "8px 12px", background: "#eff6ff", borderRadius: "6px", fontSize: "13px", color: "#1e40af" }}>
                                ℹ️ SPL Live is disabled. Enable it to show in app.
                            </div>
                        )}
                        {config.isActive && !config.videoUrl && (
                            <div style={{ marginTop: "12px", padding: "8px 12px", background: "#fef3c7", borderRadius: "6px", fontSize: "13px", color: "#92400e" }}>
                                ⚠️ Add a video URL for users to watch.
                            </div>
                        )}
                        {config.isActive && config.videoUrl && (
                            <div style={{ marginTop: "12px", padding: "8px 12px", background: "#dcfce7", borderRadius: "6px", fontSize: "13px", color: "#166534" }}>
                                ✅ SPL Live is active! Users can see & watch.
                            </div>
                        )}
                    </div>

                    {/* Instructions */}
                    <div style={{
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        border: "1px solid #e5e7eb",
                    }}>
                        <h4 style={{ margin: "0 0 10px 0" }}>How It Works</h4>
                        <ul style={{ paddingLeft: "16px", margin: 0, fontSize: "13px", color: "#4b5563", lineHeight: "1.8" }}>
                            <li>Animated orange ticker appears above banner on home screen</li>
                            <li>Shows title with scrolling text and LIVE badge</li>
                            <li>User taps → video player opens</li>
                            <li>Supports YouTube & direct video links</li>
                            <li>Toggle ON/OFF anytime from here</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SplLive;
